// src/pages/Unauthorized.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-yellow-50 p-6">
      <h1 className="text-3xl font-bold text-yellow-600 mb-4">Unauthorized access</h1>
      <p className="text-gray-700 text-center mb-6">
        You do not have access to this feature with your current subscription.
      </p>
      {/* <Link
        to="/subscription/upgradeplan"
        className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-900 transition"
      >
        Upgrade plan
      </Link> */}
    </div>
  );
};

export default Unauthorized;
